'use strict';

var _ = require('lodash');
var JqxGridDirective = function JqxGridDirective($timeout) {
  return {
    restrict: 'E',
    replace: true,
    controller: 'JqxGridController',
    template: require('../templates/jqx-grid.html'),
    scope: {
      gridId: '@',
      gridData: '=',
      gridSettings: '=',
      gridFeaturesModel: '='
    },
    transclude: {
      'toolbar': '?rmGridToolbar',
      'features': '?rmGridFeatures'
    },
    link: function link($scope) {
      $scope.updateData = function () {
        if ($scope.jqxInitialized) {
          $scope.getJqxGridElement().jqxGrid($scope.buildJqxGridSource());
        }
      };
      $scope.$watch('gridData', $scope.updateData);
      $scope.$watch('gridSettings', function () {
        if ($scope.jqxInitialized) {
          $scope.updateJqxGridSettings();
          $scope.getJqxGridElement().jqxGrid('columngroups', $scope.jqxGridSettings.columngroups);
          $scope.getJqxGridElement().jqxGrid('columns', $scope.jqxGridSettings.columns);
          $scope.getJqxGridElement().jqxGrid('height', $scope.jqxGridSettings.height);
          $scope.getJqxGridElement().jqxGrid('width', $scope.jqxGridSettings.width);
        }
      });
      $scope.registerGridEventHandlers = function () {
        _.forEach($scope.jqxGridEventHandlers, function (handlers) {
          _.forEach(handlers, function (eventHandler, eventName) {
            if (_.isFunction(eventHandler)) {
              $scope.getJqxGridElement().on(eventName, eventHandler);
            }
          });
        });
      };
      $scope.initializeGrid = function () {
        $scope.updateJqxGridSettings();
        $scope.getJqxGridElement().jqxGrid($scope.jqxGridSettings);
        if (!$scope.jqxInitialized) {
          $scope.registerGridEventHandlers();
        }
        $scope.jqxInitialized = true;
      };
      $scope.timeoutInit = function () {
        $timeout($scope.initializeGrid, 100);
      };
      $scope.timeoutInit();
    }
  };
};
JqxGridDirective.$inject = ['$timeout'];
module.exports = JqxGridDirective;